import { memo } from 'react';
import type { ReactNode } from 'react';
import { HStack, Text, Tooltip, VStack } from '@library';
import styles from './ProductStockIndicator.module.scss';

const PersistedProductStockIndicatorContent = ({
    restrictionMessage,
    classNames,
    messageStyle,
    stockMessage,
    branchName,
    dataTestClass,
    dataTestState,
    availabilityIndicatorContent,
}: {
    restrictionMessage?: string;
    classNames: string;
    messageStyle: 'left' | 'right' | 'tooltip' | 'none';
    stockMessage: string;
    branchName: string;
    dataTestClass: string;
    dataTestState?: string;
    availabilityIndicatorContent: ReactNode;
}) => {
    return (
        <Tooltip
            content={
                <div className={styles.tooltip}>
                    {restrictionMessage ? (
                        <VStack gap="mini">
                            <Text primary bold>
                                {branchName}
                            </Text>
                            <Text primary>{restrictionMessage}</Text>
                        </VStack>
                    ) : (
                        <Text primary>{branchName}</Text>
                    )}
                </div>
            }
            placement="top"
            showArrow
            disabled={!branchName}
        >
            <div>
                <HStack
                    align="center"
                    gap="micro"
                    reversed={messageStyle === 'left'}
                >
                    <div
                        className={classNames}
                        data-test-class={dataTestClass}
                        data-test-state={dataTestState}
                    >
                        {availabilityIndicatorContent}
                    </div>
                    <Text
                        secondary
                        regular
                        data-test-class="availability-persist-message"
                    >
                        <span className={styles.stockMessage}>
                            {stockMessage}
                        </span>
                    </Text>
                </HStack>
            </div>
        </Tooltip>
    );
};

export default memo(PersistedProductStockIndicatorContent);
